<template>
  <div :class="name">
    <MemberList/>
  </div>
</template>

<script>
import MemberList from '@/container/MemberList';

export default {
  components: {
    MemberList,
  },
  // computed: {
  //   ...mapGetters([
  //     'getClassNameByException',
  //     'base',
  //     'companies',
  //   ]),
  //   computedData() {
  //     const data = [];
  //     this.getClassNameByException.forEach((member) => {
  //       data.push(member);
  //     });
  //     return data;
  //   },
  // },
  // mounted() {
  // },
  // methods: {
  //   handleChangeCompany() {
  //     this.$store.dispatch('GET_CONFIG_DATA');
  //   },
  // },
  data() {
    return {
      name: 'Member',
      email: '',
    };
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/Member.vue